"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IERC721ReceiverUpgradeable__factory", {
  enumerable: true,
  get: function get() {
    return _IERC721ReceiverUpgradeable__factory.IERC721ReceiverUpgradeable__factory;
  }
});

var _IERC721ReceiverUpgradeable__factory = require("./IERC721ReceiverUpgradeable__factory");